/**
 * ÌTURA gift chooser — cart drawer + cart page (Prestige, 2026-08-16).
 *
 * Ships as an asset, not an inline script, deliberately: Prestige re-renders the cart drawer by
 * swapping innerHTML, and scripts injected that way never execute. A delegated listener bound once
 * on `document` survives every drawer refresh.
 *
 * Contract with snippets/itura-gift-picker.liquid:
 *   [data-itura-gift-add]      = variant id to add, with [data-itura-gift-tier] = "Tier 1|Tier 2|Hero"
 *   [data-itura-gift-surprise] = full cart-attribute value, e.g. "Surprise me (Tier 2)"
 * Slip markers must stay exact — fulfillment reads them off the order.
 */
(function () {
  if (window.__ituraGiftBound) return;
  window.__ituraGiftBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function isCartPage() {
    try {
      if (window.themeVariables && window.themeVariables.settings) {
        return window.themeVariables.settings.pageType === 'cart';
      }
    } catch (e) {}
    return window.location.pathname.indexOf('/cart') !== -1;
  }

  function afterCartChange() {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function fail(button, message) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = message;
  }

  function post(url, payload) {
    return fetch(root.replace(/\/$/, '') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart request failed');
      return response.json();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-itura-gift-add], [data-itura-gift-surprise]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var surprise = button.getAttribute('data-itura-gift-surprise');

    if (surprise) {
      post('/cart/update.js', { attributes: { 'Gift Preference': surprise } })
        .then(afterCartChange)
        .catch(function () {
          fail(button, 'Please try again');
        });
      return;
    }

    var variantId = parseInt(button.getAttribute('data-itura-gift-add'), 10);
    var tierLabel = button.getAttribute('data-itura-gift-tier') || 'Tier 1';

    post('/cart/add.js', {
      items: [{ id: variantId, quantity: 1, properties: { '_ITURA Gift': tierLabel + ' pick' } }]
    })
      .then(afterCartChange)
      .catch(function () {
        fail(button, 'Out of stock - pick another');
      });
  });
})();
